// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3bmjk","head":"ProcedureTableInfo_head__3UfXH"};